module.exports = __webpack_public_path__ + "static/img/huanzhe2.a11d398e.webp";